import { createUppyPlugin } from '@dott/core';

export const UppyPlugin = createUppyPlugin({
  endpoint: import.meta.env.VITE_DOTT_API_URL,
  cookiesRule: 'include',
});
